export default __webpack_public_path__ + "static/media/Roboto-BlackItalic.e81d595c.woff";